import React, { useState, useEffect } from 'react';
import { getDocuments, uploadDocument, deleteDocument } from '../../api';
import '../../styles/AdminStyles.css';

const DocumentsAdmin = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const data = await getDocuments();
      setDocuments(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file || !title) {
      alert('Заполните название и выберите файл');
      return;
    }
    const formData = new FormData();
    formData.append('title', title);
    formData.append('file', file);
    setUploading(true);
    try {
      await uploadDocument(formData);
      setTitle('');
      setFile(null);
      fetchDocuments();
    } catch (err) {
      console.error(err);
      alert('Ошибка загрузки');
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (id, fileName) => {
    if (window.confirm(`Удалить документ "${fileName}"?`)) {
      try {
        await deleteDocument(id);
        fetchDocuments();
      } catch (err) {
        console.error(err);
        alert('Ошибка удаления');
      }
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '—';
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} КБ`;
    return `${(kb / 1024).toFixed(1)} МБ`;
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-header">
        <h1 className="admin-title">Управление документами</h1>
        <button onClick={() => window.location.href = '/admin'} className="admin-logout-btn">Назад</button>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Загрузить новый документ</div>
        <form onSubmit={handleUpload} className="admin-form">
          <div className="admin-form-row">
            <label>Название документа *</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>
          <div className="admin-form-row">
            <label>Файл (PDF, DOC, TXT, XLS и др.) *</label>
            <input type="file" onChange={handleFileChange} required />
          </div>
          <button type="submit" className="admin-btn admin-btn-primary" disabled={uploading}>
            {uploading ? 'Загрузка...' : 'Загрузить'}
          </button>
        </form>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Список документов</div>
        {loading && <div className="loading-spinner">Загрузка...</div>}
        {!loading && documents.length === 0 && <div>Нет загруженных документов</div>}
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr><th>Название</th><th>Файл</th><th>Размер</th><th>Дата</th><th>Действия</th></tr>
            </thead>
            <tbody>
              {documents.map(doc => (
                <tr key={doc.id}>
                  <td>{doc.title}</td>
                  <td>{doc.original_name}</td>
                  <td>{formatFileSize(doc.size)}</td>
                  <td>{new Date(doc.created_at).toLocaleDateString()}</td>
                  <td>
                    <button onClick={() => handleDelete(doc.id, doc.title)} className="admin-btn admin-btn-danger">Удалить</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DocumentsAdmin;